import sign from "../../assets/sign.png";
import model from "../../assets/model.jpg";
import addinfo from "../../assets/add-info.png";

function ModelReview() {
    return ( 
        <>
            <section className="about-before-model">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-5 model">
                            <img src={addinfo} alt="" />
                        </div>
                        <div className="col-12 col-md-12 col-lg-7">
                            <div className="description-about">
                                <p>
                                <span className="color">
                                    We support all types of content. Your success on OnlyFans is driven by the quality and originality of your work, not by how bold it is.
                                </span>
                                </p>
        
                                <p>
                                Thinking about becoming a model but not sure where to start? Or maybe you’ve launched an OnlyFans but are struggling to attract fans, generate engagement, or make sales. That’s where we come in. We don’t just guide you—we build a customized production strategy designed to maximize your success. Our team provides clear, detailed guidelines, so you know exactly what content to create. This ensures that your account is set up for effective promotion and sales on the platform. With our support, you can focus on your creativity while we handle the rest.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="model-review">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-7">
                            <div className="quote">
                            <span className="quote-sign">"</span>Joining this team was a total game-changer! I used to feel stuck on OnlyFans, but now I’m raking in $10,000 a month with just an hour of work a day.
                            <br /><br />
                            Their marketing and content strategies are pure gold. Huge thanks for helping me turn my hustle into a dream life. If you want to skyrocket your OnlyFans, these guys are the real deal!
                            </div>
                            <div className="sign">
                                    <img src={sign} alt="" />
                            </div>
                            <div className="name">
                                Amanda
                            </div>
                            <div className="name-title">
                                OnlyFans Content Creator
                            </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-5">
                            <div className="model">
                                <img src={model} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
     );
}

export default ModelReview;